import objectFitImages from 'object-fit-images'

objectFitImages(
  document.querySelectorAll('.cover-image')
)
